function changeHistory() {
  this.delete = function(id) {
    $.send('change_history/delete/' + id, {}, function(result) {
      if (!result.length) {
        makeModal({id:"modal-sm",messages:"Изменение успешно отменено",modalDialogClass:"modal-sm"})
        $('#change_' + id).remove();
      }
    });
  }
}